<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="cursor: pointer;" (click)="minimise=!minimise"></i>
    <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
  </div>
</div>

@if (!showFormLoader && templateMode !== 'entity-edit') {
<div class="modal-tabs-wrapper" [hidden]="minimise">
  <ul class="nav nav-pills modal-tabs">
    <li class="nav-item" [class.active]="activeTab === 'map'">
      <button type="button" class="nav-link" (click)="selectTab('map')">Add New Tax/ME Codes</button>
    </li>
    <li class="nav-item" [class.active]="activeTab === 'update'">
      <button type="button" class="nav-link" (click)="selectTab('update')">Assign/Update Chart Code</button>
    </li>
  </ul>
</div>
}

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader && templateMode !== 'entity-edit' && activeTab === 'map') {
<div>
    <div class="mode-toggle">
      <label><input type="radio" [(ngModel)]="entityTypeChange" value="taxCode" (change)="onEntityTypeChange()"> ADD Tax Code</label>
      <label><input type="radio" [(ngModel)]="entityTypeChange" value="meCode" (change)="onEntityTypeChange()"> ADD ME Code</label>
    </div>

    <div class="table-scroll-wrapper">
      <table class="table table-bordered form-inline custom-table">
        <thead>
        <tr>
          <th>Source System</th>
          <th>LEID</th>
          <th>Reporting Period</th>
          <th>Tax Code</th>
          <th>ME Code</th>
          <th>Currency</th>
          <th>Ledger</th>
          <th>Chart Code</th>
        </tr>
        </thead>
        <tbody>
        @for (tbData of gridDataList; track $index; let i = $index) {
<tr>
          <td>{{ tbData.SOURCE_SYSTEM_FLAG }}</td>
          <td>{{ tbData.LEID }}</td>
          <td>{{ tbData.REPORTING_PERIOD }}</td>
          <td>
            @if (entityTypeChange === 'taxCode') {
<input class="form-control" [class.field-error]="tbData.taxCode_Error" [ngModel]="tbData.TaxCODE_EDIT" (ngModelChange)="tbData.TaxCODE_EDIT=$event; validateChangedFields(i, 'TAX_CODE')" />
}
            @if (entityTypeChange === 'meCode') {
<span>{{ tbData.CDR_NO }}</span>
}
          </td>
          <td>
            <select class="form-control" [class.field-error]="tbData.me_Error" [ngModel]="tbData.ME_EDIT" (ngModelChange)="tbData.ME_EDIT=$event; validateChangedFields(i, 'ME_CODE')">
              <option value=""></option>
              @for (me of medisplay; track $index) {
<option [value]="me">{{ me }}</option>
}
            </select>
          </td>
          <td>
            @if (tbData.SOURCE_SYSTEM_FLAG === 'D') {
<input class="form-control" [ngModel]="tbData.CURR_EDIT" disabled />
}
            @if (tbData.SOURCE_SYSTEM_FLAG !== 'D') {
<select class="form-control" [class.field-error]="tbData.curr_Error" [ngModel]="tbData.CURR_EDIT" (ngModelChange)="tbData.CURR_EDIT=$event; validateChangedFields(i, 'CURR')">
              <option value=""></option>
              @for (c of currdisplay; track $index) {
<option [value]="c">{{ c }}</option>
}
            </select>
}
          </td>
          <td>
            <input class="form-control" [class.field-error]="tbData.ledger_Error" [ngModel]="tbData.LEDGER_EDIT" (ngModelChange)="tbData.LEDGER_EDIT=$event; validateChangedFields(i, 'LEDGER')" />
          </td>
          <td>
            <select class="form-control" [class.field-error]="tbData.chart_Error" [ngModel]="tbData.CHARTCODE_EDIT" (ngModelChange)="tbData.CHARTCODE_EDIT=$event; validateChangedFields(i, 'CHART')">
              <option value=""></option>
              @for (chart of (tbData.SOURCE_SYSTEM_FLAG === 'D' ? dcsChart : firChart); track $index) {
<option [value]="chart.CHART_CODE">{{ chart.CHART_CODE }}</option>
}
            </select>
          </td>
        </tr>
}
        </tbody>
      </table>
    </div>

    <div class="modal-footer inline-footer">
      <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
      </button>
      <button class="reset-button" type="button" (click)="reset()">Reset</button>
      <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    </div>

    @if (entityLookUpinit) {
<div class="panel panel-default">
      <div class="panel-heading">
        Entity LookUp
        <i class="glyphicon" [ngClass]="{'glyphicon-chevron-down': entitylookUpMapping, 'glyphicon-chevron-up': !entitylookUpMapping}" style="float: right; cursor: pointer; margin-right: 20px;" (click)="entitylookUpMapping=!entitylookUpMapping"></i>
        <div class="btn btn-success btn-xs entity-lookup-badge" (click)="entitylookUpMapping=!entitylookUpMapping">Entity LookUp</div>
      </div>
      @if (entitylookUpMapping) {
<div class="panel-body">
        <div class="table-scroll-wrapper">
          <table class="table table-bordered form-inline custom-table">
            <thead>
            <tr>
              <th>Entity</th>
              <th>ME Code</th>
              <th>Currency</th>
              <th>Ledger</th>
              <th>Chart Code</th>
            </tr>
            </thead>
            @if (existingChartData.length === 0) {
<tbody>
            <tr><td colspan="5" class="loading-table"><b>No Existing Combinations</b></td></tr>
            </tbody>
}
            @if (existingChartData.length > 0) {
<tbody>
            @for (adjs of existingChartData; track $index) {
<tr>
              <td>{{ adjs.ENTITY }}</td>
              <td>{{ adjs.ME_CODE }}</td>
              <td>{{ adjs.CURR }}</td>
              <td>{{ adjs.LEDGER }}</td>
              <td>{{ adjs.CHART_CODE }}</td>
            </tr>
}
            </tbody>
}
          </table>
        </div>
      </div>
}
    </div>
}
  </div>
}

  @if (!showFormLoader && templateMode !== 'entity-edit' && activeTab === 'update') {
<div class="tab-update-wrap">
    <gtw-entity-chart-update-ce></gtw-entity-chart-update-ce>
  </div>
}

  @if (!showFormLoader && templateMode === 'entity-edit') {
<div class="entity-feild-modal">
    <div class="entity-feild-row entity-feild-apply-row">
      <div class="entity-feild col">
        <label><b>LEID</b></label>
      </div>
      @for (field of updateFields; track $index) {
<div
           class="entity-feild"
           [class.entity-date-input-feild]="isDateField(field)">
        <label><b>{{ getLabel(field) }}</b></label>
        @if (isDateField(field)) {
<input
               class="form-control entity-input-feild date-input"
               type="date"
               [value]="toDateInputValue(updateDraft[field])"
               (input)="onDateInput(updateDraft, field, $event)" />
} @else {

          <input class="form-control entity-input-feild" type="text"
                 [placeholder]="getLabel(field)"
                 [ngModel]="updateDraft[field]"
                 (ngModelChange)="updateDraft[field]=$event" />
        
}
        
        <button class="apply-btn" type="button" (click)="applyValues(field, updateDraft[field])">Apply</button>
      </div>
}
    </div>

    <div class="entity-feild-row entity-feild-separator"></div>

    @for (row of updateRows; track $index) {
<div class="entity-feild-row entity-feild-data-row">
      <div class="entity-feild col">
        <div class="input-group">{{ row.LEID }}</div>
      </div>
      @for (field of updateFields; track $index) {
<div
           class="entity-feild"
           [class.entity-date-input-feild]="isDateField(field)">
        @if (isDateField(field)) {
<input
               class="form-control entity-input-feild date-input"
               type="date"
               [value]="toDateInputValue(row[field])"
               (input)="onDateInput(row, field, $event)" />
} @else {

          <div class="input-group">
            <input class="form-control entity-input-feild" type="text"
                   [placeholder]="getLabel(field)"
                   [ngModel]="row[field]"
                   (ngModelChange)="row[field]=$event" />
          </div>
        
}
        
      </div>
}
    </div>
}

    @if (updateRows.length === 0) {
<div class="no-rows-message">No Rows to update</div>
}
  </div>
}
</div>

@if (!showFormLoader && templateMode === 'entity-edit') {
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="saveEntityUpdates()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Update Entities
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
}
